import type { ProductSort } from '@/shared/api/types/generated';
import type { DropdownOption } from '@/shared/components/ui/Dropdown';

export const getAvailableProductSorts = (): DropdownOption[] => [
  { value: 'newest', label: '🕒 Plus récent' },
  { value: 'oldest', label: '🕒 Plus ancien' },
  { value: 'priceDesc', label: '💰 Prix décroissant' },
  { value: 'priceAsc', label: '💰 Prix croissant' },
];

export const getProductSortLabel = (sort: ProductSort): string => {
  const option = getAvailableProductSorts().find((opt) => opt.value === sort);
  return option?.label ?? sort;
};
